export default {
    IS_LOGGED_IN: 'vcc.isLoggedin',
    USER_DATA: 'vcc.userInfo',
    TOKEN: 'vcc.token',
    DISPLAY_NAME: 'vcc.displayName',
    LANGUAGE: 'vcc.language',
}